import Request from "@arcgis/core/request";
import {
  arcgisServicesLandFeatureUrl,
  arcgisServicesBaseMinistryUrl,
} from "../../../configs/arcgisServices";
import Query from "@arcgis/core/rest/support/Query";
import { getBaladyAccessToken } from "../../../services/API/baladyService";
import { getAllRegionsData, getCitiesDataOfRegion, getDistrictsDataOfCity, getParcelsDataOfPlan, getPlanDataOfDistrict } from "../../../services/API";

// API URLs for geospatial services
export const API_URLS = {
  regions: arcgisServicesLandFeatureUrl + "3/query",
  cities: arcgisServicesBaseMinistryUrl + "3/query", 
  districts: arcgisServicesBaseMinistryUrl + "2/query",
  subdivisionPlans: arcgisServicesBaseMinistryUrl + "5/query",
  parcels: arcgisServicesBaseMinistryUrl + "0/query",
} as const;

/**
 * Gets regions data
 */

export const getRegions = async (
  setIsLoading: (loading: boolean) => void,
  setRegions: (regions: any[]) => void,
  presentToastFunction: any,
  presentToast: any
) => {
  setIsLoading(true);
  let zonesArray: any = [];
  
  try {
    const token = await getBaladyAccessToken(); 
    const response: any = await getAllRegionsData(token);
    if (
      response.data.data.result.length > 0
    ) {
      response.data.data.result.forEach((result: any, index: number) => {
        zonesArray.push({
          name:
            result.regionName != null
              ? result.regionName
              : "بدون اسم",
          key: result.regionCode ?? index,
          // graphic: result.geometry,
        });
      });
      setRegions(zonesArray);
    } else {
      setRegions([]);
      presentToastFunction(
        presentToast,
        "top",
        "warning",
        `لا توجد بيانات مرتبطة بالبيانات المختاره`
      );
    }
  } catch (err) {
    console.error("Error fetching regions:", err);
    setRegions([]);
    presentToastFunction(
      presentToast,
      "top",
      "warning",
      `لا توجد بيانات مرتبطة بالبيانات المختاره`
    );
  } finally {
    setIsLoading(false);
  }
};

/**
 * Gets cities of a specific region
 */
export const getCitiesOfRegion = async (
  selectedRegion: string,
  setIsLoading: (loading: boolean) => void,
  setCities: (cities: any[]) => void,
  presentToastFunction: any,
  presentToast: any
) => {
  setIsLoading(true);
  let CitiesArray: any = [];
  
  try {
    const token = await getBaladyAccessToken(); 
    const response: any = await getCitiesDataOfRegion(selectedRegion, token);
    if (
      response.data.data.result.length > 0
    ) {
      response.data.data.result.forEach((result: any, index: number) => {
        CitiesArray.push({
          name:
            result.name != null
              ? result.name
              : "بدون اسم",
          key: result.code ?? index,
          graphic: {
            rings: result.rings ?? []
          }
        });
      });
      setCities(CitiesArray);
    } else {
      setCities([]);
      presentToastFunction(
        presentToast,
        "top",
        "warning",
        `لا توجد بيانات مرتبطة بالبيانات المختاره`
      );
    }
  } catch (err) {
    console.error("Error fetching cities:", err);
    setCities([]);
    presentToastFunction(
      presentToast,
      "top",
      "warning",
      `لا توجد بيانات مرتبطة بالبيانات المختاره`
    );
  } finally {
    setIsLoading(false);
  }
};

/**
 * Gets districts of a specific city
 */
export const getDistrictOfCity = async (
  selectedRegion: string,
  selectedCity: string,
  setIsLoading: (loading: boolean) => void,
  setDistricts: (districts: any[]) => void,
  presentToastFunction: any,
  presentToast: any
) => {
  setIsLoading(true);
  let districtArray: any = [];
  
  try {
    const token = await getBaladyAccessToken(); 
    const response: any = await getDistrictsDataOfCity(selectedRegion, selectedCity, token);
    if (
      response.data.data.result.length > 0
    ) {
      response.data.data.result.forEach((result: any, index: number) => {
        districtArray.push({
          name:
            result.districtName != null
              ? result.districtName
              : "بدون اسم",
          key: result.districtCode ?? index,
          // keySelected: result.objectId ?? index,
          graphic: {
            rings: result.rings ?? []
          }
        });
      });
      setDistricts(districtArray);
    } else {
      setDistricts([]);
      presentToastFunction(
        presentToast,
        "top",
        "warning",
        `لا توجد بيانات مرتبطة بالبيانات المختاره`
      );
    }
  } catch (err) {
    console.error("Error fetching districts:", err);
    setDistricts([]);
    presentToastFunction(
      presentToast,
      "top",
      "warning",
      `لا توجد بيانات مرتبطة بالبيانات المختاره`
    );
  } finally {
    setIsLoading(false);
  }
};

/**
 * Gets parcels for a specific subdivision plan and district
 */
export const getPlans = async (
  selectedRegion: string,
  selectedCity: string,
  selectedDistrict: string,
  setIsLoading: (loading: boolean) => void,
  setParcels: (parcels: any[]) => void,
  presentToastFunction: any,
  presentToast: any
) => {
  setIsLoading(true);
  let parcelsArr: any = [];

  try {
    const token = await getBaladyAccessToken(); 
    const response: any = await getPlanDataOfDistrict(selectedRegion, selectedCity, selectedDistrict, token);
    if (
        response.data.data.result.length > 0
    ) {
      response.data.data.result.forEach((result: any, index: number) => {
        const planLabel =
          result.planName != null && result.planNO != null
            ? `${result.planNO} - ${result.planName}`
            : "بدون اسم";

        parcelsArr.push({
          name: planLabel,
          key: result.planNO ?? index,
          graphic: {
            rings: result.rings ?? []
          }
        });
      });
      setParcels(parcelsArr);
    } else {
      setParcels([]);
      presentToastFunction(
        presentToast,
        "top",
        "warning",
        `لا توجد بيانات مرتبطة بالبيانات المختاره`
      );
    }
  } catch (err) {
    console.error("Error fetching parcels:", err);
    setParcels([]);
    presentToastFunction(
      presentToast,
      "top",
      "warning",
      `لا توجد بيانات مرتبطة بالبيانات المختاره`
    );
  } finally {
    setIsLoading(false);
  }
};

/**
 * Gets parcels for a specific subdivision plan and district
 */
export const getParcels = async (
  selectedRegion: string,
  selectedCity: string,
  selectedDistrict: string,
  planNo: string,
  setIsLoading: (loading: boolean) => void,
  setParcels: (parcels: any[]) => void,
  presentToastFunction: any,
  presentToast: any
) => {
  setIsLoading(true);
  let parcelsArr: any = [];

  try {
    const token = await getBaladyAccessToken(); 
    const response: any = await getParcelsDataOfPlan(selectedRegion, selectedCity, selectedDistrict, planNo, token);
    if (
        response.data.data.result.length > 0
    ) {
      response.data.data.result.forEach((result: any, index: number) => {
        const parcelLabel =
          result.landuse != null && result.parcelNO != null
            ? `${result.parcelNO} - ${result.landuse}`
            : "بدون اسم";

        parcelsArr.push({
          name: parcelLabel,
          key: result.parcelNO ?? index,
          graphic: {
            rings: result.rings ?? []
          }
        });
      });
      setParcels(parcelsArr);
    } else {
      setParcels([]);
      presentToastFunction(
        presentToast,
        "top",
        "warning",
        `لا توجد بيانات مرتبطة بالبيانات المختاره`
      );
    }
  } catch (err) {
    console.error("Error fetching parcels:", err);
    setParcels([]);
    presentToastFunction(
      presentToast,
      "top",
      "warning",
      `لا توجد بيانات مرتبطة بالبيانات المختاره`
    );
  } finally {
    setIsLoading(false);
  }
};

/**
 * Creates feature geometry for queries
 */
export function featureGeometry(type: any, features: any, wKid: any) {
  let obj: any = {
    type: type,
    spatialReference: {
      wkid: wKid,
    },
  };
  switch (type) {
    case "polyline":
      obj["paths"] = features;
      break;
    case "polygon":
      obj["rings"] = features;
  }
  return obj;
}

/**
 * Gets graphic from object ID
 */
export const getGraphicFromObj = async (
  obj: any,
  setIsLoading: (loading: boolean) => void,
  zoomToLayer: any,
  presentToastFunction: any,
  presentToast: any
) => {
  let REGA_20MapServiceURL = arcgisServicesLandFeatureUrl + "1/query";
  let queryOption: any = {
    responseType: "json",
    query: {
      f: "json",
      where: `ParcelCode in (${obj}) `,
      returnCountOnly: false,
      outFields: "*",
      returnDistinctValues: false,
      returnGeometry: true,
    },
  };
  
  try {
    const response: any = await Request(REGA_20MapServiceURL, queryOption);
    if (response.data.features.length >= 0) {
      zoomToLayer(
        "polygon",
        response.data.features[0].geometry.rings[0],
        4326,
        false
      );
    } else {
      presentToastFunction(
        presentToast,
        "top",
        "danger",
        `يرجى التاكد من رقم القطعة`
      );
    }
  } catch (error: any) {
    console.error("Error getting graphic from object:", error);
  } finally {
    setIsLoading(false);
  }
};

/**
 * Gets intersection with graphics for a given geometry
 */
export const getIntersectWithGraphics = async (graphic: any, layer: any) => {
  try {
    const query = layer.createQuery();
    query.geometry = graphic;
    query.spatialRelationship = "intersects";
    query.outFields = ["*"];
    
    const results = await layer.queryFeatures(query);
    return results.features;
  } catch (error) {
    console.error("Error getting intersection with graphics:", error);
    return [];
  }
};

/**
 * Gets region name by GIS query
 */
export const getRegionNameByGis = async (MapViewData: any, setCurrentRegion: (region: string | null) => void) => {
  let currentReionExtentName = "";

  const query = new Query();
  query.geometry = MapViewData.center;
  query.spatialRelationship = "intersects";
  query.returnGeometry = false;
  
  try {
    const res: any = await window.F_Region.queryFeatures(query);
    
    // Check if features exist before accessing attributes
    if (res.features && res.features.length > 0 && res.features[0].attributes) {
      let regionName = res.features[0].attributes.REGIONNAME_AR;
      
      if (currentReionExtentName == "") {
        currentReionExtentName = regionName;
        console.log("regionName", regionName);
        console.log("call api for get big user for adds==>1");
        setCurrentRegion(currentReionExtentName);
      }
      if (currentReionExtentName != regionName) {
        console.log("regionName", regionName);
        console.log("call api for get big user for adds==>2");
        currentReionExtentName = regionName;
        setCurrentRegion(currentReionExtentName);
      }
      return "ok";
    } else {
      // No region found, set to null
      setCurrentRegion(null);
      return "no_region";
    }
  } catch (error) {
    console.error("Error getting region name:", error);
    // Set region to null on error
    setCurrentRegion(null);
    return "error";
  }
};
